
$(function () {
    $("[stems-ajax-list]").each(function (idx, element) {
        var url = $(this).data("url");

        if (url) {
            $(function () {
                $.ajax({
                    url: url,
                    method: "GET",
                    dataType: "html",
                    success: function (d) {
                        $(element).html(d);
                    },
                    error: function (x, s, e) {
                        $(element).html("<div class='no-data'><i class='fas fa-exclamation-triangle'></i><p>Oops! Something went wrong</p></div>");
                    }
                });
            });
        }
    });
})